'use client';

import React, { useEffect, useState } from 'react';
import { STORE_TYPES } from '@/constants/types';
import { cn } from '@/utils/cn';
import TextSmall from '../Typography/TextSmall';

function StoreLocator({ typeOfBadge, className = '' }) {
  const { STORE, SERVICE_CENTER } = STORE_TYPES;
  const [badgeType, setBadgeType] = useState({
    name: null,
    bgColor: null,
    color: null,
  });

  function formatText(text) {
    if (!text) return '';

    return text
      .split(' ')
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
      .join(' ');
  }

  useEffect(() => {
    switch (typeOfBadge) {
      case STORE:
        setBadgeType({
          name: typeOfBadge,
          bgColor: '#DB0032',
          color: '#FFF',
        });
        break;
      case SERVICE_CENTER:
        setBadgeType({
          name: typeOfBadge,
          bgColor: '#DAE3F2',
          color: '#49525E',
        });
        break;
      case 'authorized-dealer':
        setBadgeType({
          name: typeOfBadge,
          bgColor: '#49525E',
          color: '#FFF',
        });
        break;
      default:
        setBadgeType({
          name: null,
          bgColor: null,
          color: null,
        });
    }
  }, [typeOfBadge]);

  return (
    <div
      className="w-max rounded-tl-[12px] py-2 lg:py-6 pl-8 lg:pl-8 pr-8 lg:pr-12 rounded-br-[12px]"
      style={{ backgroundColor: badgeType.bgColor }}
    >
      <TextSmall
        text={formatText(badgeType.name)}
        className={cn(`font-semibold md:font-bold text-center`, className)}
        style={{ color: badgeType.color }}
      />
    </div>
  );
}

export default StoreLocator;
